import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Html } from 'cccisd-wysiwyg';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import style from './style.css';
import { LicensingContext } from '../../context/LicensingContext';

function MainLayout(props) {
    const { isLicenseNeeded, status } = useContext(LicensingContext);

    let component = <></>;
    if (!isLicenseNeeded || status === true) {
        component = props.children;
    } else if (typeof status === 'string') {
        component = <Html content={status} />;
    }

    return (
        <div className={style.wrapper}>
            <div className={style.header}>
                <Header className={props.className} />
            </div>

            <div className={style.body}>
                <div className={props.className}>{component}</div>
            </div>

            <div className={style.footer}>
                <Footer className={props.className} />
            </div>
        </div>
    );
}

MainLayout.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

MainLayout.defaultProps = {
    className: 'container',
};

export default MainLayout;
